import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getLocalDataAsObject } from "../utils/AppHelper";

const PrivateRoute = ({ Component }) => {
  //const { token } = useSelector((state) => state.user);
  
  const token = getLocalDataAsObject("authtoken");
  return token ? <Component /> : <Navigate to="/login" />;
};
export default PrivateRoute;
